<h2>{{'packsTexts.invoiceTitle' | translate}}</h2>
<form #invoiceForm="ngForm" name="form" (ngSubmit)="invoiceForm.valid">
  <div class="form-group full-width divider">
    <br>
    <mat-radio-group [(ngModel)]="selectedClientType" name="choice">
      <mat-radio-button *ngFor="let clientType of clientTypes" [value]="clientType.value" (click)="onClientTypeClick(clientType)">
        {{ ('packsTexts.' + clientType.label) | translate }}
      </mat-radio-button>
    </mat-radio-group>
    
    <br>
    <br>

    <!-- INDIVIDUAL CLIENT -->
    <div class="container-fluid" *ngIf="isSelectedClientIndividual()">
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{(buyer.isLegal?'packsTexts.buyer':'packsTexts.name') | translate}}</p>
            <input matInput name="name" [(ngModel)]="buyer.name" #name="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field *ngIf="!buyer.isLegal">
            <p class="title">{{'packsTexts.middleName' | translate}}</p>
            <input matInput name="middleName" [(ngModel)]="buyer.middleName" #middleName="ngModel" readonly />
          </mat-form-field>
          <mat-form-field *ngIf="!buyer.isLegal">
            <p class="title">{{'packsTexts.familyName' | translate}}</p>
            <input matInput name="familyName" [(ngModel)]="buyer.familyName" #familyName="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field *ngIf="!buyer.isLegal">
            <p class="title">{{'packsTexts.country' | translate}}</p>
            <input type="text" matInput name="country" [(ngModel)]="buyer.country" #country="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-lg-6" *ngIf="!buyer.isLegal">
          <mat-form-field>
            <p class="title">{{'packsTexts.idType' | translate}}</p>
            <input type="text" matInput name="idType" [(ngModel)]="buyer.idType" #idType="ngModel" readonly />
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{(buyer.isLegal ?'packsTexts.legalBuyer':'packsTexts.idNumber') | translate}}</p>
            <input matInput name="idNumber" [(ngModel)]="buyer.idNumber" #idNumber="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="buyer.isLegal">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{'packsTexts.vatNumber' | translate}}</p>
            <input matInput name="vatIdNumber" [(ngModel)]="buyer.vatIdNumber" #vatNumber="ngModel" readonly />
          </mat-form-field>
          <mat-form-field>
            <p class="title">{{'packsTexts.custodianOfProperty' | translate}}</p>
            <input matInput name="custodianOfProperty" [(ngModel)]="buyer.custodianOfProperty"
              #custodianOfProperty="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.city' | translate}}</p>
            <input type="text" matInput name="city" [(ngModel)]="buyer.city" #city="ngModel" readonly />
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.postalCode' | translate}}</p>
            <input matInput name="postalCode" [(ngModel)]="buyer.postalCode" #postalCode="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{'packsTexts.address' | translate}}</p>
            <input matInput name="address" [(ngModel)]="buyer.address" #address="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

      <!--
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{'packsTexts.email' | translate}}</p>
            <input matInput name="email" [(ngModel)]="buyer.email" #email="ngModel" type="email" pattern="^[^а-яА-Я ]+@[^а-яА-Я ]+$" />
            <mat-error *ngIf="email.invalid">{{getErrorMessage("wrongEmail", email.errors)}}</mat-error>
          </mat-form-field>
        </div>
      </div>
      -->

    </div>

    <!-- COMPANY IDENTITY VALUE SECTION -->
    <div class="container-fluid" *ngIf="showCompanyIdValueSection()">

      <!--EIK FORM-->
      <div class="row">

        <div class="col-lg-6">
          <mat-form-field style="width: 100%;" 
          [color]="companyIdValueModel.invalid && (companyIdValueModel.touched || submitted) ? 'warn' : ''">
            
            <p class="title">{{ 'packsTexts.legalEntityText.idValueText' | translate }}</p>
            
            <input
              matInput
              name="companyIdValue"
              required
              [(ngModel)]="companyIdValue"
              (ngModelChange)="checkRestrictedPayer()"
              #companyIdValueModel="ngModel"
            />

            <button
              mat-button
              matSuffix
              color="primary"
              (click)="onCheckCompanyIdValue(companyIdValueModel)"
              class="verify-button"
              [disabled]="!companyIdValue || isSearchingCompany || isRestrictedPayer"
            >
              {{ 'packsTexts.legalEntityText.verifyCompanyIdentity' | translate }}
            </button>

          </mat-form-field>

          <!-- Error message if invalid + either touched or submitted -->
          <mat-error *ngIf="companyIdValueModel.invalid && (companyIdValueModel.touched || submitted)">
            {{ getErrorMessage('wrongIdNumber', companyIdValueModel.errors) }}
          </mat-error>

          <mat-error *ngIf="isRestrictedPayer">
             {{ 'packsTexts.legalEntityText.payerIsNotAllowed' | translate }}
          </mat-error>

        </div>

        <div class="col-lg-6">
          <mat-form-field appearance="fill" style="width: 100%;">
            <p class="title">
              {{ 'packsTexts.legalEntityText.companyCountry' | translate }}
            </p>
        
            <mat-select
              [(ngModel)]="selectedCountry"
              name="companyCountry"
              (selectionChange)="checkRestrictedPayer()"
            >
              <mat-option *ngFor="let country of countries" [value]="country">
                {{ getCountryName(country) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>

    </div>


    <!-- LegalEntity CLIENT -->
    <div class="container-fluid" *ngIf="showCompanyData()">

      <!--NameBg, NameEn-->
      <div class="row">
        <!--NameBg-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.legalEntityName' | translate}}</p>
            <input matInput name="nameBg" [(ngModel)]="companyData.nameBg" #nameBg="ngModel" readonly />
          </mat-form-field>
        </div>

        <!--NameEn-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.legalEntityNameEn' | translate}}</p>
            <input matInput name="nameEn" [(ngModel)]="companyData.nameEn" #nameEn="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>


      <!--IdValue, VatNumber-->
      <div class="row">
        <!--IdValue-->

        <div class="col-lg-6">
          <mat-form-field style="width: 100%;">
            <p class="title">{{ 'packsTexts.legalEntityText.idValueText' | translate }}</p>
            
            <input
              matInput
              [(ngModel)]="companyData.idValue"
              name="idValue"
              readonly
            />

            <button
              mat-button
              matSuffix
              color="primary"
              (click)="clearCompanyData()"
              style="margin-right: 4px; font-weight: bold;"
            >
              <mat-icon class="close-icon-btn">close</mat-icon>
            </button>

          </mat-form-field>
        </div>

        <!--VatNumber-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.vatNumberText' | translate}}</p>
            <input matInput name="companyVatNumber" [(ngModel)]="companyData.companyVatNumber" #companyVatNumber="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

      <!-- CompanyType, CompanyStatisticGroup -->
      <div class="row">

        <!-- CompanyType -->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyType' | translate}}</p>
            <input matInput name="companyType" [(ngModel)]="companyType" #companyTypeModel="ngModel" readonly />
          </mat-form-field>
        </div>



      <!--CompanyStatisticGroup Dropdown-->
      <div class="col-lg-6">
        <mat-form-field>
          <p class="title">{{'packsTexts.legalEntityText.companyStatisticGroup' | translate}}</p>
          <input matInput name="companyStatisticGroup" [(ngModel)]="companyStatisticGroup" #companyStatisticGroupModel="ngModel" readonly />
        </mat-form-field>
      </div> 

      </div>

      <!--Addres title-->
      <div class="left-text-divider">
        <span>{{'packsTexts.legalEntityText.addressTitle' | translate}}</span>
        <div class="line"></div>
      </div>

      <!--CompanyCountry-->
      <div class="row">

        <!--CompanyCountryBg-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.country' | translate}}</p>
            <input matInput name="companyCountry" [(ngModel)]="companyCountry.bg" #companyCountryModel="ngModel" readonly />
          </mat-form-field>
        </div>
        <!--CompanyCountryEn-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.countryEn' | translate}}</p>
            <input matInput name="companyCountryEn" [(ngModel)]="companyCountry.en" #companyCountryModelEn="ngModel" readonly />
          </mat-form-field>
        </div>

      </div>

      <!--CompanyCity-->
      <div class="row">
        <!--CompanyCityBg-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyCityBgText' | translate}}</p>
            <input matInput name="companyCityBg" [(ngModel)]="companyData.companyCityBg" #companyCityBg="ngModel" readonly />
          </mat-form-field>
        </div>

        <!--CompanyCityEn-->
        <div class="col-lg-6">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyCityEnText' | translate}}</p>
            <input matInput name="companyCityEn" [(ngModel)]="companyData.companyCityEn" #companyCityEn="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

      <!--CompanyPostalCode-->
      <div class="row">
        <div class="col-lg-3">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyPostalCodeText' | translate}}</p>
            <input matInput name="companyPostalCode" [(ngModel)]="companyData.companyPostalCode" #companyPostalCode="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

      <!--CompanyAddressBg-->
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyAddressBg' | translate}}</p>
            <input matInput name="companyAddressBg" [(ngModel)]="companyData.companyAddressBg" #companyAddressBg="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

      <!--CompanyAddressEn-->
      <div class="row">
        <div class="col-lg-9">
          <mat-form-field>
            <p class="title">{{'packsTexts.legalEntityText.companyAddressEn' | translate}}</p>
            <input matInput name="companyAddressEn" [(ngModel)]="companyData.companyAddressEn" #companyAddressEn="ngModel" readonly />
          </mat-form-field>
        </div>
      </div>

    </div>

    <!--NOT FOUND COMPANY PAYER POPUP-->
    <cloud-popup
      *ngIf="showPopupNotFoundPayer"
      [message]="'packsTexts.legalEntityText.buyCQESPackageInStore' | translate"
      [linkText]="'packsTexts.legalEntityText.estoreBorica' | translate"
      [linkUrl]="this.PURCHASE_CQES_PACKAGES_ESTORE"
      (closed)="showPopupNotFoundPayer = false">
    </cloud-popup>

  </div>
</form>